import * as React from 'react'

type SwUpdateState = {
  supported: boolean
  hasWaiting: boolean
  swState: string | null
  controller: boolean
}

const DEFAULT_STATE: SwUpdateState = {
  supported: typeof navigator !== 'undefined' && 'serviceWorker' in navigator,
  hasWaiting: false,
  swState: null,
  controller: false,
}

export function useSwUpdateStatus() {
  const [state, setState] = React.useState<SwUpdateState>(DEFAULT_STATE)

  const refresh = React.useCallback(async () => {
    if (!('serviceWorker' in navigator)) {
      setState({ ...DEFAULT_STATE, supported: false })
      return
    }
    try {
      const reg = await navigator.serviceWorker.getRegistration()
      const sw = reg?.waiting || reg?.installing || reg?.active || null
      setState({
        supported: true,
        hasWaiting: !!reg?.waiting,
        swState: sw ? (sw as any).state || null : null,
        controller: !!navigator.serviceWorker.controller,
      })
    } catch {
      setState({ ...DEFAULT_STATE, supported: true })
    }
  }, [])

  const checkForUpdate = React.useCallback(async () => {
    if (!('serviceWorker' in navigator)) return false
    try {
      const reg = await navigator.serviceWorker.getRegistration()
      if (!reg) return false
      await reg.update()
      await refresh()
      return true
    } catch {
      return false
    }
  }, [refresh])

  React.useEffect(() => { void refresh() }, [refresh])

  return { ...state, refresh, checkForUpdate }
}
